jQuery(document).ready(function()
{

    // Remove tags from taxonomy filter dropdowns
    jQuery('.acf-input select[data-filter="taxonomy"] optgroup[label="Tag"]').remove();
    jQuery('.acf-input select[data-filter="taxonomy"] optgroup[label="Prominent word"]').remove();

    // Add a department sort into the Nested Pages toolbar
    if( typeof tollersDeptList !== 'undefined' )
    {
        var tollersFilters = jQuery('<form class="tollers-filters" action="' + [location.protocol, '//', location.host, location.pathname].join('') + '" method="GET"></form>')

        // Prepare a select to append to the filter form
        var tollersDeptSelect = jQuery('<div class="select"><select name="department"></select></div>');

        // Add a placeholder option
        tollersDeptSelect.children('select').append( jQuery('<option value="">Department</option>') );

        // Get the IDs of each department
        var departmentIDs = Object.keys( tollersDeptList );


        departmentIDs.sort( function ( a, b ) {
            return tollersDeptList[b] < tollersDeptList[a];
        } );

        jQuery( departmentIDs ).each( function( index, deptID ) {

            // Create an option for each department
            let newOption = jQuery('<option></option>');

            // Set the option value and label
            newOption.val(deptID);
            newOption.text(tollersDeptList[deptID])

            // Add the option to the dropdown
            tollersDeptSelect.children('select').append(newOption);
        } );

        tollersFilters.append( jQuery(
            '<input type="hidden" name="page" value="' + getParameterByName( 'page' ) + '">'
        ));

        // Add the new filter to the collection
        tollersFilters.append(tollersDeptSelect);

        // Add the filter button
        tollersFilters.append( jQuery('<input type="submit" class="button" value="Filter">') );

        // Add all filters to the page
        jQuery('.np-tools-primary').append(tollersFilters);

        // Check if the filter has already been applied
        var currentDept = getParameterByName( 'department' );

        if( currentDept !== null && currentDept !== '' )
        {
            // Select the relevant option
            tollersDeptSelect.find( '[value="' + currentDept + '"]').attr('selected', 'selected');
        }
    }
});

function getParameterByName(name, url)
{
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


// jQuery( document ).ready(function() {


//     var relatedServices = jQuery(".acf-rel-item");


//     console.log(relatedServices);
    
//     jQuery("[data-name='related_services'].acf-rel-item").each(function() {
//         console.log("test");
//     });
// });

